import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import useParseHashFilters from './useParseHashFilters';
import useParseQueryFilters from './useParseQueryFilters';
import useParseConfigFilters from './useParseConfigFilters';
import useGetFiltersFromLS from '../Fetch/useGetFiltersFromLS';
import { setFiltersFromLS, setMainDealerId } from '../../redux/filtersReducer';
import { filterInitialState, tier3ListOfDealers } from '../../utils/analyticsEventListeners';
import { setInitialSortBy } from '../../redux/sortByReducer';
import getMarket from '../../utils/getMarket';
import { listOfDealersType, setConfig, setMarket } from '../../redux/appConfigReducer';
import { setSortBy } from '../../redux/vehiclesReducer';

const useFilterProcessor = (config: any) => {
  const dispatch = useDispatch();

  const isTier3page = config?.isTier3page;
  const isDynamicUrlParams = config?.isUrlParamsDynamic;

  const tier3HashParams = useParseHashFilters();
  const parsedQueryParamsTier1 = useParseQueryFilters();
  const parsedConfigFilters = useParseConfigFilters(config);

  const parsedParamsTier3 = isTier3page && isDynamicUrlParams ? tier3HashParams : null;

  const setParamsToLS = useCallback(() => {
    localStorage.setItem('selectedFilters-v5', JSON.stringify(parsedQueryParamsTier1));
  }, [parsedQueryParamsTier1]);

  if (!isTier3page) setParamsToLS();

  const filtersFromLS = useGetFiltersFromLS();

  const parsedParams = isTier3page ? parsedParamsTier3 : parsedQueryParamsTier1;

  useEffect(() => {
    if (parsedConfigFilters?.isTier3page) {
      // On Tier3 pages priority is with url params but if there is no params we'll grab it from config
      const filters = parsedParams || parsedConfigFilters.tier3Filters;
      dispatch(setFiltersFromLS(filters));
      filterInitialState(filters);
      return;
    }
    if (!filtersFromLS) return;
    filterInitialState(filtersFromLS);
    dispatch(setFiltersFromLS(filtersFromLS));
  }, [
    dispatch,
    parsedConfigFilters?.isTier3page,
    parsedConfigFilters?.tier3Filters,
    filtersFromLS,
    parsedParams,
  ]);

  useEffect(() => {
    const sortByFromLS = localStorage.getItem('sortBy');
    if (sortByFromLS && !isTier3page) {
      // LATER - For DEV team : making sure this works fine for Tier 1
      dispatch(setInitialSortBy(JSON.parse(sortByFromLS)));
      return;
    }
    if (isTier3page) {
      dispatch(
        setSortBy({
          direction: 'ASC',
          id: 'DATE_PREDATEEND',
          value: 'DATE_PREDATEEND:ASC',
        }),
      );
    }
  }, [dispatch, isTier3page]);

  useEffect(() => {
    const market = getMarket();

    // just passing market if NO remote config or Tier3 is false(parsedConfig is null)
    if (!isTier3page) {
      dispatch(setMarket(config.marketType));
      return;
    }

    if (!config || isEmpty(config) || !parsedConfigFilters) {
      dispatch(setMarket(market));
      return;
    }

    const mainDealer = parsedConfigFilters?.listOfDealers?.find(
      (dealer: listOfDealersType) => dealer?.isMainDealer,
    )?.dealerId;
    tier3ListOfDealers(config);
    dispatch(setConfig(parsedConfigFilters));
    dispatch(setMainDealerId(mainDealer));
  }, [isTier3page, config.marketType, dispatch, parsedConfigFilters, config]);
};

export default useFilterProcessor;
